import React, { Component } from 'react';
import { FormGroup, Label, FormText } from 'reactstrap';

import { isValidIpWhitelistEntry } from '../helpers/apiKeys';

/**
* Chip input for the API key IP whitelist (VD-725).
* Accepts IPv4, IPv4 CIDR and IPv6 (with optional prefix length). An empty list
* means the key may be used from any address.
*/
class IpWhitelistInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            draft: '',
            error: null,
        };
    }

    get entries() {
        return this.props.value && this.props.value.length ? this.props.value : [];
    }

    commit = (raw) => {
        let candidates = String(raw).split(/[\s,;]+/).filter((item) => item);

        if (!candidates.length) {
            this.setState({ draft: '', error: null });
            return;
        }

        let entries = [...this.entries];
        let invalid = [];

        for (let i = 0; i < candidates.length; i++) {
            let entry = candidates[i].trim();

            if (!isValidIpWhitelistEntry(entry)) {
                invalid.push(entry);
                continue;
            }

            if (entries.indexOf(entry) === -1) {
                entries.push(entry);
            }
        }

        this.setState({
            draft: invalid.join(' '),
            error: invalid.length
                ? `${'Not a valid IP address or CIDR range'.translate(this.props.lang)}: ${invalid.join(', ')}`
                : null,
        });

        if (entries.length !== this.entries.length) {
            this.props.onChange(entries);
        }
    }

    remove = (entry) => {
        this.props.onChange(this.entries.filter((item) => item !== entry));
    }

    onKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',' || e.key === ' ' || e.key === 'Tab') {
            if (!this.state.draft.trim()) {
                return;
            }

            // Tab keeps its default behaviour so the user can still leave the field
            if (e.key !== 'Tab') {
                e.preventDefault();
            }

            this.commit(this.state.draft);
            return;
        }

        if (e.key === 'Backspace' && !this.state.draft && this.entries.length) {
            e.preventDefault();
            this.remove(this.entries[this.entries.length - 1]);
        }
    }

    render() {
        let entries = this.entries;

        return (
            <FormGroup>
                {this.props.label ? <Label size="sm">{this.props.label}</Label> : null}

                <div className={`ip-whitelist-input ${this.props.disabled ? 'disabled' : ''}`}>
                    {entries.map((entry) => (
                        <span className="ip-whitelist-chip" key={entry}>
                            {entry}
                            {!this.props.disabled ?
                                <button
                                    type="button"
                                    aria-label={'Remove'.translate(this.props.lang)}
                                    onClick={() => this.remove(entry)}
                                >&times;</button>
                                : null}
                        </span>
                    ))}

                    {!this.props.disabled ?
                        <input
                            type="text"
                            value={this.state.draft}
                            placeholder={entries.length ? '' : '1.2.3.4, 5.5.5.0/24, 2001:db8::1'}
                            onChange={(e) => this.setState({ draft: e.target.value, error: null })}
                            onKeyDown={this.onKeyDown}
                            onBlur={() => this.state.draft.trim() ? this.commit(this.state.draft) : null}
                        />
                        : null}
                </div>

                {this.state.error ?
                    <FormText color="danger">{this.state.error}</FormText>
                    :
                    <FormText color="muted">
                        {!entries.length
                            ? 'Empty = access allowed from any IP address'.translate(this.props.lang)
                            : 'Press Enter or comma to add an address. IPv4, CIDR and IPv6 are supported.'.translate(this.props.lang)}
                    </FormText>
                }
            </FormGroup>
        );
    }
}

export default IpWhitelistInput;
